<template>
  <div >
    <hints-slide :hints="hints" />
    <statistics :company-created-at="companyCreatedAt" @remove-hint="removeHint" @add-hint="addHint" />
    <insights-indication :company-created-at="companyCreatedAt" @remove-hint="removeHint" @add-hint="addHint" />
    <patients-overview :company-created-at="companyCreatedAt" />
  </div>
</template>

<script>
import InsightsIndication from "./insights-indication"
import Statistics from "./statistics"
import PatientsOverview from "./patients-overview"
import HintsSlide from "./hints-slide.vue"

export default {
  components: {
    InsightsIndication,
    HintsSlide,
    Statistics,
    PatientsOverview
  },
  props: {
    companyCreatedAt: String,
  },
  data(){
    return {
      hints: []
    }
  },
  methods: {
    addHint(hint) {
      const hintExists = this.hints.find(item => item.id == hint.id)
      if (hintExists) {
        return false;
      }
      this.hints.push(hint)
    },
    removeHint(hint) {
      this.hints = this.hints.filter(item => item.id != hint.id)
    }
  },
};
</script>
